import http from "./httpService";
import { CreateOrUpdateExternalItemMappingDto } from "../types/apiTypes";

const apiEndpoint = "/services/app/ExternalItemMapping";

export function getProjectExternalItemMapping(projectId: number) {
  return http.get(
    apiEndpoint + `/GetItems?projectId=${projectId}` + `&maxResultCount=500`
  );
}

export function processProjectExternalItemMapping(
  data: CreateOrUpdateExternalItemMappingDto
) {
  return http.post(apiEndpoint + "/CreateOrUpdate", data);
}
